import React from 'react';
import { withRouter } from 'react-router-dom';
import { MainSearch } from 'us.common/components';
import { RouteComponentProps } from 'react-router-dom';

const Cnt_MainSearch: React.FC<RouteComponentProps> = (props) => {
	return <MainSearch {...props} />;
};

export default withRouter(Cnt_MainSearch);
